import { FC } from 'react';
import ProDropdown, { DropDownProps } from './dropdown';
import ProTabPane, { DropdownButtonProps } from './button';

export type IDropdownComponent = FC<DropDownProps> & {
  Button: FC<DropdownButtonProps>,
};

const TransDropdown = ProDropdown as IDropdownComponent;
TransDropdown.Button = ProTabPane;

export default TransDropdown;